import { mapState } from 'vuex';
import event from "./event/index.vue";
import courseprogress from "../progress/index.vue";
import f from '@/application/shared/functions.js'

export default {
    name: 'joined',
    props: {
        id : String
    },

    components : {
        event,
        courseprogress
    },

    data : function(){

        return {
            loading : false,
            error : null,
            course : null,
            lastScroll : 0,
            rendered : false,
            focused : null,
            observer : null,
            storyview : true
        }

    },

    created() {

        
    },

    watch: {
        id : {
            immediate : true,
            handler : function(){
                this.destroy()
                this.create()
                this.load()
            }
        },

        progress : {
            handler : function(){

                
                
            }
        }
    },
    computed: mapState({
        android : function(){
            return window.cordova && !f.isios()
        },
        auth : state => state.auth,
        haslicense : function(){
            return true //this.core.user.checkFeatures(['lessons'])
        },
        mobileview : state => state.mobileview,
        modals : state => state.modals,
        playingstory : state => state.playingstory,

        progress : function(state){

            if(!this.course) return new this.core.api.kt.LessonProgress()

            return state._progress[this.course.uid] || (new this.core.api.kt.LessonProgress())
        },

        events : function(){
            

            if(!this.course) return []

            var events = _.map([...this.course.lessons || []].reverse(), (lesson, index) => {
                return {
                    "uid" : lesson.uid,
                    "id" : lesson.uid,
                    "type": "message",
                    "data": {
                        "story": lesson.story,
                        "type": "story"
                    }
                }
            })

            events.push({
                type : 'message',
                uid : 'intro',
                system : true,
                data : {
                    type : 'system',
                    template : 'intro',
                    course : this.course
                }
            })

            events.unshift({
                type : 'message',
                uid : 'last',
                system : true,
                data : {
                    type : 'system',
                    template : 'last',
                    course : this.course
                }
            })

            return events
        },
        lessonStatuses : function(){
            var ls = this.progress.lessonStatuses(this.course, 'lesson')
            
            return ls
        },

        focusedProgressIndex : function(){
            if (this.focused){
                return this.focused.replace('lesson', '')
            }

            return ''
        }
    }),

    methods : {
        destroy : function(){
            this.destroyObserver()
        },
        create : function(){

        },
        componentscrolling : function(e){
            this.$emit('componentscrolling', e)

            var scroll = e.target.scrollTop

            if (scroll < this.lastScroll){
            }

            this.lastScroll = e.target.scrollTop
            
        },  

        scrollToNext : function(){
            if(!this.progress || !this.course) return

            var nextlesson = this.progress.next(this.course)

            if (nextlesson){
                this.scrollToEvent(nextlesson.uid)
            }
            else{
                if(this.progress.finished(this.course)){
                    this.scrollToEvent('end')
                }
                
            }
        },

        scrollToEnd : function(){

            const container = this.$refs["events"];

            if(!container) return

            this.scroll(container.scrollHeight - container.clientHeight)

        },

        scrollToEvent : function(eventId){

            if(!eventId) return

            if (eventId == 'end') return this.scrollToEnd()
            if (eventId == 'start') return this.scroll(0)

            var r = this.$refs['event_wrapper_' + eventId]

            if (r){

                const container = this.$refs["events"];

                if(!container) return

                this.scroll(r[0].offsetTop)
            }

        },

        scroll(s) {
			const container = this.$refs["events"];

            if(!container) return

			if (container.scrolling) {
				container.scrolling(-1, s);
			} else {
				container.scrollTop = s;
			}
		},

        load : function(){

            if(!this.id){
                this.error = '404'

                return
            }

            this.loading = true
            this.resloading = true
            
            var promise = this.core.api.lessons.get(this.id)

            this.observer = null

            promise.then((course) => {
                this.course = course

                return this.core.api.lessons.progress.get([this.id])

            }).then((progress) => {

                if(!this.progress.join()){
                    return Promise.reject({error : 'empty'})
                }

            }).then(() => {

                setTimeout(() => {

                    this.rendered = true

                    this.createObserver()

                    this.scrollToNext()

                }, 200)

            }).catch(e => {
                console.error(e)
                this.rendered = true
                this.error = e
            }).finally(() => {
                this.loading = false
            })

        },

        cevent : function(data){

            if (data.name == 'tolessons'){
                this.scrollToNext()
            }

            if (data.name == 'end'){
                var index = data.value.uid.replace('lesson', '')

                this.finishLesson(Number(index))
            }

            if (data.name == 'toback'){
                this.$router.push('/courses').catch(e => {})
            }
            
        },

        finishLesson : function(index){

            if(!this.auth) return
            if (this.progress.check(index)) return

            this.core.api.lessons.progress.set(this.course.uid, index, 5).then(() => {

                this.$store.commit('delayedAction', {
                    time : 5000,
                    text : 'snippity.course.finishedlesson',
                    action : () => {
                        this.scrollToNext()
                    }
                })

            }).catch(e => {
            })
        },

        destroyObserver : function() {
            if (this.observer){
                this.observer.disconnect()
                this.observer = null
            }
        },

        clickProgress : function(index){
            this.scrollToEvent('lesson' + index)
        },

        createObserver : function() {

            if(!this.$refs.chatroot) return

            this.observer = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.focused = entry.target.getAttribute('uid')
                    }
                });
                },
                {
                    root : this.$refs.chatroot,
                    threshold: 0.5
                }
            );
          
            const sections = this.$refs.chatroot.querySelectorAll(".ewrapper");

            sections.forEach((section) => this.observer.observe(section));
        },
    },
}